import { render, staticRenderFns } from "./MainArea.vue?vue&type=template&id=e291a5c8&"
import script from "./MainArea.vue?vue&type=script&lang=ts&"
export * from "./MainArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports